import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20fashion%20photography%20featuring%20diverse%20streetwear%20pieces%20arranged%20in%20dynamic%20diagonal%20composition%20on%20textured%20concrete%20surface%2C%20premium%20sneakers%20in%20foreground%20with%20terracotta%20hoodie%20and%20accessories%20scattered%20naturally%2C%20warm%20golden%20hour%20sunlight%20casting%20long%20dramatic%20shadows%2C%20urban%20loft%20aesthetic%20with%20exposed%20brick%2C%20European%20contemporary%20style%2C%20rich%20terracotta%20and%20sage%20green%20accents%20against%20grey%20neutral%20backdrop%2C%20high-end%20magazine%20editorial%20quality%2C%20sophisticated%20yet%20approachable%20lifestyle&width=1920&height=1080&seq=hoobuy-hero-v2-main-2026-z8x5&orientation=landscape"
          alt="Hoobuy Spreadsheet - Produtos verificados e planilha atualizada"
          title="Hoobuy Spreadsheet em Português 2026"
          className="w-full h-full object-cover object-top"
        />
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/35"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 pt-20">
        <div className="max-w-4xl">
          {/* Tag */}
          <span className="inline-block px-4 py-1.5 border border-white/40 rounded-full text-white text-xs md:text-sm font-medium tracking-wide mb-6 md:mb-8">
            Planilha Atualizada 2026
          </span>

          {/* Main Heading */}
          <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl text-white font-medium leading-tight mb-6 md:mb-8">
            Hoobuy Spreadsheet
            <br />
            em Português 2026
          </h1>

          {/* Subheadline */}
          <p className="text-white/85 text-base md:text-lg max-w-xl mb-8 md:mb-10 leading-relaxed">
            Descubra os melhores produtos, links verificados e planilhas atualizadas do Hoobuy.
            Mais de 10.000 produtos organizados em categorias.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-start gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2.5 px-7 py-3.5 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Explorar Spreadsheet
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2.5 px-7 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 text-sm md:text-base font-semibold rounded-full hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer"
            >
              Ver Produtos Populares
              <i className="ri-shopping-bag-line text-lg"></i>
            </a>
          </div>

          {/* Article Links - Quick Access */}
          <div className="mt-8 md:mt-10 flex flex-wrap items-center gap-3">
            <Link
              to="/artigo/guia-completo-hoobuy-spreadsheet"
              className="inline-flex items-center gap-2 text-white/70 hover:text-white text-sm transition-colors cursor-pointer"
            >
              <i className="ri-article-line"></i>
              Ler o Guia Completo
              <i className="ri-arrow-right-line"></i>
            </Link>
            <span className="text-white/30 hidden sm:inline">|</span>
            <Link
              to="/artigo/guia-de-compras-hoobuy"
              className="inline-flex items-center gap-2 text-white/70 hover:text-white text-sm transition-colors cursor-pointer"
            >
              <i className="ri-shopping-bag-3-line"></i>
              Guia de Compras
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}